import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Model_Datasource, AbsPaginatedGrid } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DatasourceService } from './datasource.service';

@Injectable()
export class DatasourceOnlineService extends DatasourceService {
    constructor(
        protected _httpClient: HttpClient,
        protected _apiService: ApiService,
    ) {
        super(_httpClient, _apiService);
    }

    doSyncDatasourceAction(_responseWorkflow: Model_Datasource) {
        return this._httpClient.post<void>(this._apiService.endPoints.doSyncDatasourceAction_SynchronisationPeripherique, _responseWorkflow)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
    
    doGetDatasourceByNum(_num: string) {
        return this._httpClient.get<Model_Datasource>(this._apiService.endPoints.doGetDatasourceByNum + '/' + _num)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doBuildDatasourceByNumAction(_num: string) {
        return this._httpClient.get<AbsPaginatedGrid<any>>(this._apiService.endPoints.doBuildDatasourceByNumAction + '/' + _num)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
}